import React, { useState } from "react";
import { useSelector } from "react-redux";
import Pagination from "react-js-pagination";
import ManagementModal from "../Modal";
import { studentStatus } from "../../../../helper/general";
import "./style.css";

const Table = ({ data, activePage, handlePageChange, setReload }) => {

  const classList = useSelector(state => state.student.classList);
  const sectionList = useSelector(state => state.student.sectionList);

  const [formData, setFormData] = useState({})
  const [show, setShow] = useState(false);


  const handleClose = () => setShow(false);

  const handleEdit = item => {
    const payload = {
      kidId: item?.kidId,
      name: item?.kidName,
      schoolName: item?.schoolName,
      schoolId: item?.schoolId,
      classId: classList.find(obj => obj.name == item?.className)?.id,
      sectionId: sectionList.find(obj => obj.name == item?.sectionName)?.id,
      rollNumber: item?.rollNumber,
      requestedStatus: item?.status === "ACTIVE"
    }
    setFormData(payload);
    setShow(true);
  }

  return (
    <div className="management-table card  my-4 border-0 px-2">
      <div className="row">
        <div className="col-12 mx-auto">
          <div className="detail-table">
            <div className="table mb-0">
              <div className="table-wrapper">
                <table className="table border mb-0">
                <thead>
                  <tr>
                    <th className="py-3 px-2 text-center">Name</th>
                    <th className="py-3 px-2 text-center">Admission No.</th>
                    <th className="py-3 px-2 text-center">School</th>
                    <th className="py-3 px-2 text-center">Class</th>
                    <th className="py-3 px-2 text-center">Section</th>
                    <th className="py-3 px-2 text-center">Roll no.</th>
                    <th className="py-3 px-2 text-center">Status</th>
                    <th className="py-3 px-2 text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.map((item, key) => {
                    const editable = item?.status === "UNDERREVIEW";
                    return (
                      <tr key={key}>
                        <td className="py-3 px-2">{item?.kidName}</td>
                        <td className="py-3 px-2 text-center">{item?.adminssionNumber}</td>
                        <td className="py-3 px-2 text-center">{item?.schoolName}</td>
                        <td className="py-3 px-2 text-center">{item?.className}</td>
                        <td className="py-3 px-2 text-center">{item?.sectionName}</td>
                        <td className="py-3 px-2 text-center">{item?.rollNumber}</td>
                        <td className="py-3 px-2 text-center">
                          <span className={`cstm-pill ${item?.status?.toLowerCase()}`}>{studentStatus?.[item?.status]}</span>
                        </td>
                        <td className="py-3 px-2 text-center">
                          { }
                          <button disabled={editable} onClick={() => handleEdit(item)} className="btn btns edit-btn m-0">Edit</button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              </div>
              {data?.pagination_info &&
                <div className="pagination-bar w-100 d-flex justify-content-between border-top-0">
                  <p className="counting mb-0">{activePage} out of {data?.pagination_info?.total_pages}</p>
                  <nav aria-label="Page navigation example">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={data?.pagination_info?.page_size}
                      totalItemsCount={data?.pagination_info?.total_elements}
                      pageRangeDisplayed={5}
                      innerClass="pagination mb-0 p-0"
                      itemClass="page-item"
                      linkClass="page-link"
                      onChange={handlePageChange}
                    />
                  </nav>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      {show && <ManagementModal show={show} handleClose={handleClose} data={formData} setReload={setReload} />}
    </div>
  );
};

export default Table;